import React from 'react'
import {
  FieldGrid,
  FieldGroup,
  LabeledToggleRow,
  NumberField,
  SettingsPane,
  ToggleList,
} from '../organization-ui'
import type { OrganizationSettingsFormProps } from '../settings/organizationSettingsForm.types'

export const AttendancePane: React.FC<OrganizationSettingsFormProps> = ({
  register,
  setValue,
  watch,
  errors,
  disabled = false,
}) => (
  <SettingsPane
    title="Attendance"
    description="What counts as a present day, how much lateness is forgiven, and whether lateness reaches pay."
  >
    <FieldGroup label="Thresholds">
      <FieldGrid>
        <NumberField
          label="Minimum hours for present"
          min={0}
          step={0.5}
          unit="hr"
          disabled={disabled}
          hint="Shifts below this are not counted as a full present day."
          error={errors.attendanceSettings?.minimumHoursForPresent?.message}
          {...register('attendanceSettings.minimumHoursForPresent', { valueAsNumber: true })}
        />
        <NumberField
          label="Late grace period"
          min={0}
          unit="min"
          disabled={disabled}
          hint="Arrivals inside this window are not marked late."
          error={errors.attendanceSettings?.lateGracePeriodMinutes?.message}
          {...register('attendanceSettings.lateGracePeriodMinutes', { valueAsNumber: true })}
        />
      </FieldGrid>
    </FieldGroup>

    <FieldGroup label="Pay impact">
      <ToggleList>
        <LabeledToggleRow
          label="Auto-deduct late minutes from pay"
          description="Subtract late arrival minutes when payroll is calculated."
          checked={watch('attendanceSettings.autoDeductLateMinutes') ?? false}
          disabled={disabled}
          onChange={(checked) =>
            setValue('attendanceSettings.autoDeductLateMinutes', checked, { shouldDirty: true })
          }
        />
      </ToggleList>
    </FieldGroup>
  </SettingsPane>
)

AttendancePane.displayName = 'AttendancePane'
